import { useState } from 'react';
import { useStudyYearPeriod } from '@/pages/Overview/hooks/useStudyYearPeriod';
import { useStudyYearPeriods } from '@/pages/Overview/hooks/useStudyYearPeriods';
import {
  containsPeriod,
  getDefaultPeriod,
  isSamePeriod,
} from '@/pages/Overview/period';
import { StudyYearPeriodType, type StudyYearPeriod } from '@/types/overview';

interface UseSelectedPeriodResult {
  periods: StudyYearPeriod[];
  studyYearPeriod: StudyYearPeriod;
  selectedPeriod: StudyYearPeriod;
  selectPeriod: (period: StudyYearPeriod) => void;
}

export const useSelectedPeriod = (): UseSelectedPeriodResult => {
  const { periods } = useStudyYearPeriods();
  const studyYearPeriod = useStudyYearPeriod();
  const [selectedPeriod, setSelectedPeriod] = useState<StudyYearPeriod>();

  const isCustomInStudyYear =
    selectedPeriod?.type === StudyYearPeriodType.Custom &&
    containsPeriod(studyYearPeriod, selectedPeriod);
  const availablePeriod =
    selectedPeriod &&
    periods.find((period) => isSamePeriod(period, selectedPeriod));

  return {
    periods,
    studyYearPeriod,
    selectedPeriod:
      (isCustomInStudyYear ? selectedPeriod : availablePeriod) ??
      getDefaultPeriod(periods),
    selectPeriod: setSelectedPeriod,
  };
};
